var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: "current",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 3.833a.834.834 0 11-.001 1.669.834.834 0 010-1.669zm-1.333 7.5V12h2.666v-.666a3.299 3.299 0 00-.19-.061c-.254-.076-.476-.143-.476-.429V6.667h-2v.667l.14.049c.275.093.526.178.526.482v2.978c0 .285-.22.351-.473.428a3.273 3.273 0 00-.193.062z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default "/_next/static/images/ef939f877d72772d58407100e75c51c1.svg";
export { ForwardRef as ReactComponent };